import * as React from "react";
import Form from "./Form";
import FormDialog from "../../../../components/Dialog/FormDialog";

export default function DialogCreateBoard({
  handleClose,
  open,
  workflowSteps,
}) {
  return (
    <React.Fragment>
      <FormDialog
        open={open}
        handleClose={handleClose}
        title="Create task"
        width="470px"
        fullWidth={true}
        className="dialog-content-form list-view-create-card-dialog"
        alignActions="center">
        <Form onClose={handleClose} workflowSteps={workflowSteps} />
      </FormDialog>
    </React.Fragment>
  );
}
